<app-pageheader Title="Organization Settings">
  <app-form-save-button [Parent]="Busyable" (OnSave)="OnSave()" [Form]="this"></app-form-save-button>
</app-pageheader>
@if (this.Model == null || this.Model.length == 0) {
  <div class="container content">
    <app-loader [Parent]="Busyable"></app-loader>
    <ul>
      @if (!HasSettings) {
        <div class="title">No Settings Found</div>
      }
    </ul>
  </div>
}
@if (this.Model != null && this.Model.length > 0) {
  <div class="">
    <app-tree>
      <app-treenodesettings [recursiveList]="this.Model" (updateSettingValue)="updateSettingValue($event)"></app-treenodesettings>
    </app-tree>
  </div>
}